import React from "react";

import { useTranslate } from "localization";
import { Filter } from "ui/forms";

import { useDocumentUsersQuery } from "API";

import useFilterParam from "./useFilterParam";

const DocumentUsers: React.FC = () => {
  const { translate } = useTranslate();
  const title = translate("uploadedBy");

  const { data = [], isSuccess, isError } = useDocumentUsersQuery();
  const [selected, setSelected] = useFilterParam("doc_uploaded_by", data, {
    defaultToFirst: false,
    multi: true,
    ready: isSuccess || isError,
  });
  return (
    <Filter
      items={{ options: data }}
      title={title}
      label={title}
      selected={!!selected.length}
      count={selected.length ? selected.length : void 0}
      onChange={setSelected}
      disabled={!data.length || !selected}
      value={selected}
      multi={true}
      showReset={true}
      showApply={true}
      searchable={true}
      translate={translate}
    />
  );
};

export default DocumentUsers;
